import getShop from './getShop';

const getShopBusinessType = state => getShop(state)?.businessType;

export default getShopBusinessType;
